import { IApiConfig } from './StoresApiSdk';
import { ErrorHandler } from './ErrorHandler';
import { IAPIBOPISInventory } from './BOPISApiInterfaces';
import { bopisApiUrl } from '~constants/constants';

export type IBOPISInventoryRequest = {
    brand: string;
    region: string;
    courier: number;
    include_cart?: number;
    include_store_selection: number;
    sku_ids: string[];
    include_shipmethods: number;
} & (IBOPISInventoryCoordsParams | IBOPISInventoryDoorIdsParams | IBOPISInventoryZipCodeParams);

export interface IBOPISInventoryZipCodeParams {
    mode: 'address';
    zip: string;
    radius: string;
}

export interface IBOPISInventoryCoordsParams {
    mode: 'coords';
    latitude: string;
    longitude: string;
    radius: string;
}

export interface IBOPISInventoryDoorIdsParams {
    mode: 'door_id';
    door_ids: string[];
}

export class BOPISApiSdk {
    //@ts-ignore
    private readonly businessUnit: string;
    //@ts-ignore
    private readonly BOPISUrl: string;
    private errorHandler: ErrorHandler;

    constructor(config: IApiConfig) {
        this.businessUnit = config.businessUnit;
        this.BOPISUrl = bopisApiUrl;
        this.errorHandler = new ErrorHandler();
    }

    private toQueryString = (params: IBOPISInventoryRequest) =>
        Object.keys(params)
            .map((key) => {
                // @ts-ignore
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            })
            .join('&');

    private fetchJson = async (url: string, params?: RequestInit) =>
        (await fetch(url, params)).json();

    public getBOPISInventory = async <T extends IBOPISInventoryRequest>(
        request: T
    ): Promise<IAPIBOPISInventory> =>
        this.errorHandler.tryRequest(() =>
            this.fetchJson(`${this.BOPISUrl}?${this.toQueryString(request)}`)
        );
}
